import { RemoteGetMapInternshipMarkers } from 'data/usecases/dashboard';
import { GetMapInternshipMarkers } from 'domain/usecases/dashboard';
import { makeApiUrlMapInternshipMarkers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetMapInternshipMarkers = (): GetMapInternshipMarkers =>
  new RemoteGetMapInternshipMarkers(
    makeApiUrlMapInternshipMarkers(),
    makeAxiosHttpClient(),
  );
